/**
 * 添加教参编辑页面
 * 谢冉
 * 2020.8.25
 */
import React, { useState, useEffect } from 'react';
import '@instructure/canvas-theme'
import { FormFieldGroup, FormField } from '@instructure/ui-form-field'
import { TextInput } from '@instructure/ui-text-input'
import { Button } from '@instructure/ui-buttons/es/Button'
import { Alert } from '@instructure/ui-alerts';
import { instance } from '../axios';
import { withRouter } from 'react-router-dom';
import { Select } from '@instructure/ui-select';
import EmailInfo from '../components/EmailInfo';

function AddForm(props) {
  const options = [
    { id: 'opt1', label: '教参' },
    { id: 'opt2', label: '教材' },
  ];
  const [alertToggle, setAlertToggle] = useState('none');
  const [message, setMessage] = useState([]);
  const [isShowingOptions, setIsShowingOptions] = useState(false);
  const [selectedOptionId, setSelectedOptionId] = useState(options[0].id);
  const [highlightedOptionId, setHighlightedOptionId] = useState();
  const [objInfo, setObjInfo] = useState({
    jcmc: '', // 书名
    inputValue: options[0].labe,  //类型
    isbn: '',// isbn
    zzxm: '',// 作者姓名
    cbdw: '', // 出版单位
    cbrq: '',// 出版日期
    callno: '',// 索书号
    language: '',// 语种
    internalId: '',
    id: '', // 教参id
    bsId: '',// 课程id
    userId: '',// 用户id
    isTeacher: '',// 是否为老师
  })
  const params = JSON.parse(localStorage.getItem('urlParams'));

  //  获取存储在sessionStorage里的数据，渲染页面上输入框的数据
  useEffect(() => {
    let objValue = sessionStorage.getItem('info' || {});
    console.log('编辑传递的值', objValue);
    const obj = JSON.parse(objValue);
    setObjInfo({
      bookName: obj.jcmc, // 书名
      inputValue: obj.type,  //类型
      isbn: obj.isbn,// isbn
      writer: obj.zzxm,// 作者姓名
      publisher: obj.cbdw, // 出版单位
      publicationYear: obj.cbrq,// 出版日期
      callNumber: obj.callno,// 索书号
      language: obj.language,// 语种
      internalId: obj.internalId,
      bsId: obj.bsId,// 课程id
      id: obj.jcId, // 教参id
      userId: obj.userId,// 用户id
      isTeacher: obj.isTeacher,// 是否为老师

    })
  }, []);
  console.log('ObjInfo', objInfo);
  // 题名
  const handelChangeBookName = (e) => {
    setObjInfo({
      bookName: e, // 书名
      inputValue: objInfo.inputValue,  //类型
      isbn: objInfo.isbn,// isbn
      writer: objInfo.writer,// 作者姓名
      publisher: objInfo.publisher, // 出版单位
      publicationYear: objInfo.publicationYear,// 出版日期
      callNumber: objInfo.callNumber,// 索书号
      language: objInfo.language,// 语种
      internalId: objInfo.internalId,
      bsId: objInfo.bsId,// 课程id
      id: objInfo.id, // 教参id
      userId: objInfo.userId,// 用户id
      isTeacher: objInfo.isTeacher,// 是否为老师
    })
    if (e !== '') {
      setMessage([]);
    }
  };
  // inbn
  const handelChangeIsbn = (e) => {
    setObjInfo({
      bookName: objInfo.bookName, // 书名
      inputValue: objInfo.inputValue,  //类型
      isbn: e,// isbn
      writer: objInfo.writer,// 作者姓名
      publisher: objInfo.publisher, // 出版单位
      publicationYear: objInfo.publicationYear,// 出版日期
      callNumber: objInfo.callNumber,// 索书号
      language: objInfo.language,// 语种
      internalId: objInfo.internalId,
      bsId: objInfo.bsId,// 课程id
      id: objInfo.id, // 教参id
      userId: objInfo.userId,// 用户id
      isTeacher: objInfo.isTeacher,// 是否为老师
    })
  };
  //  作者
  const handelChangeWriter = (e) => {
    setObjInfo({
      bookName: objInfo.bookName, // 书名
      inputValue: objInfo.inputValue,  //类型
      isbn: objInfo.isbn,// isbn
      writer: e,// 作者姓名
      publisher: objInfo.publisher, // 出版单位
      publicationYear: objInfo.publicationYear,// 出版日期
      callNumber: objInfo.callNumbercallno,// 索书号
      language: objInfo.language,// 语种
      internalId: objInfo.internalId,
      bsId: objInfo.bsId,// 课程id
      id: objInfo.id, // 教参id
      userId: objInfo.userId,// 用户id
      isTeacher: objInfo.isTeacher,// 是否为老师
    })
  };
  //  出版社
  const handelChangePublisher = (e) => {
    setObjInfo({
      bookName: objInfo.bookName, // 书名
      inputValue: objInfo.inputValue,  //类型
      isbn: objInfo.isbn,// isbn
      writer: objInfo.writer,// 作者姓名
      publisher: e, // 出版单位
      publicationYear: objInfo.publicationYear,// 出版日期
      callNumber: objInfo.callNumber,// 索书号
      language: objInfo.language,// 语种
      internalId: objInfo.internalId,
      bsId: objInfo.bsId,// 课程id
      id: objInfo.id, // 教参id
      userId: objInfo.userId,// 用户id
      isTeacher: objInfo.isTeacher,// 是否为老师
    })
  };
  //  出版年
  const handelChangePublicationYear = (e) => {
    setObjInfo({
      bookName: objInfo.bookName, // 书名
      inputValue: objInfo.inputValue,  //类型
      isbn: objInfo.isbn,// isbn
      writer: objInfo.writer,// 作者姓名
      publisher: objInfo.publisher, // 出版单位
      publicationYear: e,// 出版日期
      callNumber: objInfo.callNumber,// 索书号
      language: objInfo.language,// 语种
      internalId: objInfo.internalId,
      bsId: objInfo.bsId,// 课程id
      id: objInfo.id, // 教参id
      userId: objInfo.userId,// 用户id
      isTeacher: objInfo.isTeacher,// 是否为老师
    })
  };
  //  索书号
  const handelChangeCallNumber = (e) => {
    setObjInfo({
      bookName: objInfo.bookName, // 书名
      inputValue: objInfo.inputValue,  //类型
      isbn: objInfo.isbn,// isbn
      writer: objInfo.writer,// 作者姓名
      publisher: objInfo.publisher, // 出版单位
      publicationYear: objInfo.publicationYear,// 出版日期
      callNumber: e,// 索书号
      language: objInfo.language,// 语种
      internalId: objInfo.internalId,
      bsId: objInfo.bsId,// 课程id
      id: objInfo.id, // 教参id
      userId: objInfo.userId,// 用户id
      isTeacher: objInfo.isTeacher,// 是否为老师
    })
  };
  //  语种
  const handelChangeLanguage = (e) => {
    setObjInfo({
      bookName: objInfo.bookName, // 书名
      inputValue: objInfo.inputValue,  //类型
      isbn: objInfo.isbn,// isbn
      writer: objInfo.writer,// 作者姓名
      publisher: objInfo.publisher, // 出版单位
      publicationYear: objInfo.publicationYear,// 出版日期
      callNumber: objInfo.callNumber,// 索书号
      language: e,// 语种
      internalId: objInfo.internalId,
      bsId: objInfo.bsId,// 课程id
      id: objInfo.id, // 教参id
      userId: objInfo.userId,// 用户id
      isTeacher: objInfo.isTeacher,// 是否为老师
    })
  };


  // 取消
  const onCancel = () => {
    setObjInfo({
      bookName: '', // 书名
      inputValue: '',  //类型
      isbn: '',// isbn
      writer: '',// 作者姓名
      publisher: '', // 出版单位
      publicationYear: '',// 出版日期
      callNumber: '',// 索书号
      language: '',// 语种
      internalId: '',
      id: '', // 教参id
      bsId: objInfo.bsId,// 课程id
      userId: objInfo.userId,// 用户id
      isTeacher: objInfo.isTeacher,// 是否为老师
    })
    props.history.push(`/guideBooks?userId=` + objInfo.userId + `&courseId=` + objInfo.bsId + `&ghId=` + params.ghId + `&isTeacher=` + objInfo.isTeacher);
  };

  // 新增保存
  const onSave = () => {
    if (objInfo.bookName === null || objInfo.bookName === '') {
      setMessage([{ text: '请完善必填项', type: 'error' }])
    } else {
      let parameter = {
        type: objInfo.inputValue,
        bsid: objInfo.bsId,
        isbn: objInfo.isbn,
        jcmc: objInfo.bookName,
        cbdw: objInfo.publisher,
        zzxm: objInfo.writer,
        cbrq: objInfo.publicationYear,
        callno: objInfo.callNumber,
        language: objInfo.language,
        gh: params.ghId,
      }
      instance({
        method: 'post',
        url: `addReference`,
        data: parameter
      })
        .then(() => {
          props.history.push(`/guideBooks?userId=` + objInfo.userId + `&courseId=` + objInfo.bsId + `&ghId=` + params.ghId + `&isTeacher=` + objInfo.isTeacher);
        }
        )
        .catch(() => {
          setAlertToggle('block');
          setTimeout(() => {
            setAlertToggle('none');
          }, 3000);
        })
    }
  };

  // 编辑保存
  const onEdit = () => {
    if (objInfo.bookName === '' || objInfo.bookName === null) {
      setMessage([{ text: '请完善必填项', type: 'error' }])
    } else {
      let parameter = {
        type: objInfo.inputValue,
        internalId: objInfo.internalId,
        id: objInfo.id,
        bsid: objInfo.bsId,
        isbn: objInfo.isbn,
        jcmc: objInfo.bookName,
        cbdw: objInfo.publisher,
        zzxm: objInfo.writer,
        cbrq: objInfo.publicationYear,
        callno: objInfo.callNumber,
        language: objInfo.language
      }
      instance({
        method: 'post',
        url: `updateReference`,
        data: parameter
      })
        .then(() => {
          props.history.push(`/guideBooks?userId=` + objInfo.userId + `&courseId=` + objInfo.bsId + `&ghId=` + params.ghId + `&isTeacher=` + objInfo.isTeacher);
        })
        .catch(() => { })
    }
  };

  //  教材教参选择
  const getOptionById = (queryId) => {
    return options.find(({ id }) => id === queryId)
  }
  const handleSelectOption = (event, { id }) => {
    const option = getOptionById(id).label
    setSelectedOptionId(id);
    setIsShowingOptions(false);
    setObjInfo({
      bookName: objInfo.bookName, // 书名
      inputValue: option,  //类型
      isbn: objInfo.isbn,// isbn
      writer: objInfo.writer,// 作者姓名
      publisher: objInfo.publisher, // 出版单位
      publicationYear: objInfo.publicationYear,// 出版日期
      callNumber: objInfo.callNumber,// 索书号
      language: objInfo.language,// 语种
      internalId: objInfo.internalId,
      id: objInfo.id, // 教参id
      bsId: objInfo.bsId,// 课程id
      userId: objInfo.userId,// 用户id
      isTeacher: objInfo.isTeacher,// 是否为老师
    })
  }
  const handleShowOptions = (event) => {
    setIsShowingOptions(true);
  }

  const handleHideOptions = (event) => {
    const option = getOptionById(selectedOptionId).label;
    setIsShowingOptions(false);
    setObjInfo({
      bookName: objInfo.bookName, // 书名
      inputValue: selectedOptionId ? option : '',  //类型
      isbn: objInfo.isbn,// isbn
      writer: objInfo.writer,// 作者姓名
      publisher: objInfo.publisher, // 出版单位
      publicationYear: objInfo.publicationYear,// 出版日期
      callNumber: objInfo.callNumber,// 索书号
      language: objInfo.language,// 语种
      internalId: objInfo.internalId,
      id: objInfo.id, // 教参id
      bsId: objInfo.bsId,// 课程id
      userId: objInfo.userId,// 用户id
      isTeacher: objInfo.isTeacher,// 是否为老师
    })
  }

  const handleHighlightOption = (event, { id }) => {
    event.persist()
    setHighlightedOptionId(id);
  }


  return (
    <div style={{
      marginTop: '100px',
    }}>
      <FormFieldGroup rowSpacing="large" description="">
        <FormField label="*&nbsp;书名:" layout="inline" id='bookName'>
          <TextInput width="50%" placeholder="请输入" value={objInfo.bookName} messages={message} onChange={(e, value) => { handelChangeBookName(value) }} />
        </FormField>
        <FormField label="类型:" layout="inline" id='type'>
          <Select
            renderLabel=""
            inputValue={objInfo && objInfo.inputValue}
            isShowingOptions={isShowingOptions}
            width="50%"
            // onBlur={this.handleBlur}
            onRequestShowOptions={handleShowOptions}//触发了回调，要求显示选项列表。
            onRequestHideOptions={handleHideOptions}//已触发回调，要求隐藏选项列表
            onRequestHighlightOption={handleHighlightOption}//请求特定选项的触发回调将突出显示。
            onRequestSelectOption={handleSelectOption}
          >
            {options.map((option) => {
              return (
                <Select.Option
                  id={option.id}
                  key={option.id}
                  isHighlighted={option.id === highlightedOptionId}
                  isSelected={option.id === selectedOptionId}
                >
                  {option.label}
                </Select.Option>
              )
            })}
          </Select>
        </FormField>
        <FormField layout="inline" label='ISBN:' id="isbn">
          <TextInput width="50%" placeholder="请输入" value={objInfo.isbn} onChange={(e, value) => { handelChangeIsbn(value) }} />
        </FormField>
        <FormField label="著者:" layout="inline" id="writer">
          <TextInput width="50%" placeholder="请输入" value={objInfo.writer} onChange={(e, value) => { handelChangeWriter(value) }} />
        </FormField>
        <FormField label="出版单位:" layout="inline" id="publisher">
          <TextInput width="50%" placeholder="请输入" value={objInfo.publisher} onChange={(e, value) => { handelChangePublisher(value) }} />
        </FormField>
        <FormField label="出版年:" layout="inline" id=" publicationYear">
          <TextInput width="50%" placeholder="请输入" value={objInfo.publicationYear} onChange={(e, value) => { handelChangePublicationYear(value) }} />
        </FormField>
        <FormField label="索书号:" layout="inline" id="callNumber">
          <TextInput width="50%" placeholder="请输入" value={objInfo.callNumber} onChange={(e, value) => { handelChangeCallNumber(value) }} />
        </FormField>
        <FormField label="语种:" layout="inline" id=" language">
          <TextInput width="50%" placeholder="请输入" value={objInfo.language} onChange={(e, value) => { handelChangeLanguage(value) }} />
        </FormField>
      </FormFieldGroup>
      <p style={{ textAlign: 'center', marginTop: '20px', width: '80%' }} >
        <Button color="primary-inverse" margin="small" onClick={() => onCancel()}>
          取消
        </Button>
        {objInfo && objInfo.internalId && objInfo.internalId !== '' ?
          <Button color="primary" margin="small" onClick={() => onEdit()}>
            保存
          </Button>
          :
          <Button color="primary" margin="small" onClick={() => onSave()}>
            保存
        </Button>
        }
      </p>
      <div style={alertToggle && alertToggle === 'block' ?
        { display: 'block', zIndex: '99', position: 'fixed', width: '30%', bottom: '0', right: '2% ', textAlign: 'left' } :
        { display: 'none' }}>
        {
          <Alert
            variant={'error'}
            margin="small"
            renderCloseButtonLabel="Close"
          >
            保存失败
          </Alert>
        }
      </div>
      <EmailInfo/>
    </div >
  );
}

export default withRouter(AddForm);

